var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_16757)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4164 3.125C3.11672 1.5 4.31546 0 5.87382 0C7.25237 0 8.39117 1.1875 8.39117 2.625V5.875C8.75079 5.875 9.11041 5.8125 9.47003 5.8125C9.82965 5.8125 10.1293 5.8125 10.489 5.875V2.625C10.489 1.1875 11.6278 0 13.0063 0C14.5647 0 15.7634 1.5 15.5237 3.125L14.8644 6.9375C17.2019 8 19 9.875 19 12.1875V13.625C19 15.5625 17.8013 17.1875 16.0631 18.25C14.3249 19.375 12.0473 20 9.47003 20C6.89274 20 4.61514 19.375 2.87697 18.25C1.19874 17.1875 0 15.5625 0 13.625V12.1875C0 9.875 1.73817 8 4.07571 6.9375L3.4164 3.125ZM13.9653 7.4375L14.7445 2.9375C14.9243 1.8125 14.1451 0.75 13.0063 0.75C12.0473 0.75 11.2681 1.5625 11.2681 2.5625V6.6875C11.0284 6.625 10.7287 6.625 10.489 6.625C10.1293 6.625 9.82965 6.5625 9.47003 6.5625C9.11041 6.5625 8.75079 6.5625 8.39117 6.625C8.15142 6.625 7.85173 6.6875 7.61199 6.6875V2.625C7.61199 1.625 6.83281 0.8125 5.87382 0.8125C4.79495 0.8125 3.95584 1.875 4.19558 3L4.97476 7.5C2.45741 8.5 0.77918 10.25 0.77918 12.25V13.6875C0.77918 16.75 4.67508 19.25 9.47003 19.25C14.265 19.25 18.1609 16.75 18.1609 13.6875V12.25C18.2208 10.1875 16.5426 8.4375 13.9653 7.4375Z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2206 13.625C18.2206 16.6875 14.3247 19.1875 9.52972 19.1875C4.73477 19.1875 0.838867 16.6875 0.838867 13.625V12.1875H18.2805V13.625H18.2206Z",
    fill: "#FEDC90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19533 3C3.95559 1.875 4.7947 0.8125 5.87357 0.8125C6.83256 0.8125 7.61174 1.625 7.61174 2.625V6.75C8.21111 6.6875 8.81048 6.625 9.46978 6.625C10.0692 6.625 10.6685 6.6875 11.2679 6.75V2.625C11.2679 1.625 12.0471 0.8125 13.0061 0.8125C14.0849 0.8125 14.924 1.875 14.7442 3L13.965 7.5C16.4824 8.5 18.2206 10.25 18.2206 12.25C18.2206 15.3125 14.3247 17.8125 9.52972 17.8125C4.73477 17.8125 0.838867 15.3125 0.838867 12.25C0.838867 10.25 2.5171 8.5 5.03445 7.5L4.19533 3Z",
    fill: "#D1884F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07228 11.8125C7.07228 12.625 6.65272 13.3125 6.11329 13.3125C5.57385 13.3125 5.1543 12.625 5.1543 11.8125C5.1543 11 5.57385 10.3125 6.11329 10.3125C6.65272 10.3125 7.07228 11 7.07228 11.8125Z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7256 11.8125C13.7256 12.625 13.306 13.3125 12.7666 13.3125C12.2272 13.3125 11.8076 12.625 11.8076 11.8125C11.8076 11 12.2272 10.3125 12.7666 10.3125C13.306 10.3125 13.7256 11 13.7256 11.8125Z",
    fill: "#633001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_16757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancake);
export default __webpack_public_path__ + "static/media/pancake.dab5a25258dd6529bc9864b1baa320d3.svg";
export { ForwardRef as ReactComponent };